import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function FunnelChart({ stages, valueKey = 'count', labelKey = 'label', color = '#3b82f6' }) {
  const max = Math.max(1, ...stages.map((s) => s[valueKey] || 0));
  return (
    <Stack spacing={1}>
      {stages.map((s, i) => {
        const v = s[valueKey] || 0;
        const pct = (v / max) * 100;
        const prev = i > 0 ? stages[i - 1][valueKey] || 0 : null;
        const dropOff = prev != null && prev > 0 ? Math.round(((prev - v) / prev) * 100) : null;
        return (
          <Box key={s[labelKey] + i}>
            <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 0.25 }}>
              <Typography variant="caption" sx={{ fontWeight: 500 }}>{s[labelKey]}</Typography>
              <Typography variant="caption" color="text.secondary">
                {v.toLocaleString()}
                {dropOff != null && dropOff > 0 ? ` · ↘ ${dropOff}%` : ''}
                {s.subLabel ? ` · ${s.subLabel}` : ''}
              </Typography>
            </Stack>
            <Box sx={{ height: 22, bgcolor: 'rgba(0,0,0,0.04)', borderRadius: 1, overflow: 'hidden', position: 'relative' }}>
              <Box sx={{
                width: `${pct}%`, height: '100%', bgcolor: color, opacity: 0.85,
                display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
                pr: 1, transition: 'width .2s ease',
              }}>
                {pct > 12 && (
                  <Typography variant="caption" sx={{ color: 'white', fontWeight: 600 }}>
                    {v.toLocaleString()}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}
